import { IUserOutputDto } from './user-output-dto.interface';
import { OrganizationTypes } from '../enums';

export interface IOrganizationOutputDto {
    id: string;
    email: string;
    name: string;
    locale?: string;
    users?: IUserOutputDto[];
    externalId: string;
    settings?: Record<string, unknown>;
    timezone?: string;
    photo?: string;
    address?: IAddressOutputDto;
    vatNumber?: string;
    organizationTypes?: OrganizationTypes[];
}

export interface IAddressOutputDto {
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
    latitude?: string;
    longitude?: string;
}
